import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lemlist = defineConnector({
  identifier: "lemlist",
  name: "Lemlist",
  tagLine: "Email outreach",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.lemlist\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: "",
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your [Lemlist account](https://app.lemlist.com/settings), navigate to **Settings → Integrations** and copy your API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.lemlist.com/api/campaigns",
  },
});
